<div class="section-margin">
  <div class="container min-heightcontainer">
    <div class="border-div margin-bottom-0">
      <div class="tabstyle2 offerdetailstab-padding pos-relative">
        <ul class="switchingproperty margin-bottom-15 offerlistingtab">
          <li [class.active]="activeTab === Tabs.MyExchange">
            <a (click)="onSelect(Tabs.MyExchange)">
              My Exchanges
            </a>
          </li>
          <li [class.active]="activeTab === Tabs.ConnectedExchange">
            <a (click)="onSelect(Tabs.ConnectedExchange);">
              Connected Exchanges
            </a>
          </li>
        </ul>
        <div class="absolutesearch">
          <div class="floatinghead clearfix">
            <div class="rightside clearfix">
              <div class="search-sec ">
                <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
                <i class="fa fa-search icon" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 table-fixed">
          <div class="margin-top-10">

            <div class="table-responsive">
              <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                <thead>
                  <tr>
                    <th [ngClass]="{'show':activeTab === Tabs.MyExchange,'hide':activeTab !== Tabs.MyExchange}" data-orderable="false">Actions</th>

                    <th class="sticky-left z-100">Exchange ID</th>
                    <th>{{activeTab === Tabs.ConnectedExchange ? 'Principal':'Connections'}}</th>
                    <th>Primary Broker</th> 
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>LOI In Progress </th>
                    <th>Deals In Progress</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let exchange of exchangeList;let i = index ">
                    <td class="whitespacenowrap" [ngClass]="{'show':activeTab === Tabs.MyExchange,'hide':activeTab !== Tabs.MyExchange}">
                      <a class="blueone" *ngIf="exchange.ExchangeUserId === LoggedInUser.Id" (click)="openInviteeModal(Invite,'panlestyle',exchange.Id);" tooltip="Invite"><span class="icon-users icon"></span></a>
                      <a class="blueone" routerLink="/1031-registration/{{exchange.ExchangeGuid}}" [queryParams]="{prevroute:BreadCrumb.PrevPageName,link:BreadCrumb.PrevPageLink,compaignPage:'true'}" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></a>
                    </td>
                    <td class="sticky-left"><p>{{exchange.ExchangeID}}</p></td>
                    <td>
                      <p>{{activeTab === Tabs.ConnectedExchange ? exchange.PrincipalName:exchange.Connections}}</p>
                    </td>
                    <td><p>{{exchange.PrimaryBroker ? exchange.PrimaryBroker : '-'}}</p></td>
                    <td><p>{{Validation.convertUTCDateToLocalDate(exchange.StartDate) | date:'MM/dd/yyyy'}}</p></td>
                    <td><p>{{Validation.convertUTCDateToLocalDate(Validation.DateAdd(exchange.StartDate, 180)) | date:'MM/dd/yyyy'}}</p></td>
                    <td><p>{{exchange.LOIInProgress}}</p></td>
                    <td><p>{{exchange.DealsInProgress}}</p></td>

                  </tr>
                </tbody>
                <tfoot>
                  <tr *ngIf="exchangeList?.length == 0 &&!IsLoading">
                    <td colspan="8" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #Invite class="pull-left">
  <app-exchange-1031-invite [selectedExchange]="exchangeSelected" [modalRefinvite]="modalRefInvite" (reload)="reload($event)" (close)="onInviteClose($event)"></app-exchange-1031-invite>
</ng-template>
